import { Action } from 'redux';
import { IDatasourceActions } from '~src/ts/ServerApi/types/IDatasourceActions';
import { IProjectActions } from '~src/ts/ServerApi/types/IProjectActions';
import { IWorkbookActions } from '~src/ts/ServerApi/types/IWorkbookActions';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { OpenContentDetailDialog } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface OpenContentDetailDialogAction extends Action {
  content: IContentInfo;
  availableActions?: IDatasourceActions|IWorkbookActions|IProjectActions;
}

export function openContentDetailDialog(content: IContentInfo,
    availableActions?: IDatasourceActions|IWorkbookActions|IProjectActions): OpenContentDetailDialogAction {
  return {
    type: OpenContentDetailDialog,
    content,
    availableActions
  };
}

export const isOpenContentDetailDialogAction = isActionFactory<OpenContentDetailDialogAction>(OpenContentDetailDialog);
